import React from 'react';
import { TableBody, TableRow, TableCell, Typography, Checkbox } from '@mui/material';

import DateTimeText from '../../../../shared/DateTimeText';
import TableSkeletons from '../../../associatedApplicants/tableSkeletons';
import RenderIf from '../../../../renderIf';
import { Status, Link } from './components';

const DashboardBody = ({ list, selected = new Set(), headers, isFetching, handleNav = () => {} }) => {
    return (
        <TableBody>
            {list.map((item, i) => (
                <TableRow
                    key={`row-${i}`}
                    style={{ backgroundColor: i % 2 === 1 ? '#F9FBFF' : null }}
                >
                    {Object.keys(headers)?.map((key, j) => {
                        // #TODO TechDebt - Create a Table structure in the database similar to Question structure wher Table Cell Type can be defined.
                        switch (key) {
                            case 'LastName':
                            case 'FirstName':
                                return (
                                    <TableCell key={`cell-${i}-${j}`}>
                                        <Link
                                            label={item[key]}
                                            href={`/admin/application/${item.ApplicationInstanceId}`}
                                            handleNav={handleNav}
                                        />
                                    </TableCell>
                                );
                            case 'DateSubmitted':
                                return (
                                    <TableCell key={`cell-${i}-${j}`}>
                                        <RenderIf isTrue={item[key] !== null}>
                                            <Typography
                                                sx={{ fontSize: '13px', color: 'grey.field-text' }}
                                                component="div"
                                            >
                                                <DateTimeText
                                                    type="short"
                                                    date={item[key]}
                                                />
                                            </Typography>
                                        </RenderIf>
                                    </TableCell>
                                );
                            case 'StatusId':
                                return (
                                    <TableCell key={`cell-${i}-${j}`}>
                                        <RenderIf isTrue={item[key] !== null}>
                                            <Status
                                                statusId={item[key]}
                                                displayLastUpdated={false}
                                                styleOverride={{ fontSize: '13px' }}
                                            />
                                        </RenderIf>
                                    </TableCell>
                                );
                            case 'StatusID':
                                return (
                                    <TableCell key={`cell-${i}-${j}`}>
                                        <RenderIf isTrue={item[key] !== null}>{item[key]?.description}</RenderIf>
                                    </TableCell>
                                );
                            case 'Selected':
                                return (
                                    <TableCell key={`cell-${i}-${j}`}>
                                        <Checkbox
                                            size="small"
                                            checked={selected.has(`${item.ApplicationInstanceId}|${item.NotificationEmailLocation}`)}
                                            onChange={item[key]}
                                        />
                                    </TableCell>
                                );
                            default:
                                return (
                                    <TableCell key={`cell-${i}-${j}`}>
                                        <Typography sx={{ fontSize: '13px', color: 'grey.field-text' }}>{item[key]}</Typography>
                                    </TableCell>
                                );
                        }
                    })}
                </TableRow>
            ))}

            <RenderIf isTrue={isFetching}>
                <TableSkeletons headerLength={Object.entries(headers).length} />
            </RenderIf>
        </TableBody>
    );
};

export default DashboardBody;
